import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { SvcToastService } from 'projects/lib-shared-component/src/lib/svc-toast/svc-toast.service';

@Injectable({
  providedIn: 'root',
})
export class HttpErrorService {
  constructor(
    private translocoService: TranslocoService,
    private toastService: SvcToastService
  ) {}

  public showErrorInToast(error: HttpErrorResponse, fallbackMessage?: string): void {
    const msg = this.getErrorMessage(error, fallbackMessage);
    this.toastService.error(this.translocoService.translate(msg));
  }

  // AB#71448: `fallbackMessage` lets a caller keep its own context-specific text (e.g. "Erro ao
  // carregar o arquivo") for responses that carry no server message, without losing the server
  // message when there is one.
  public getErrorMessage(error: HttpErrorResponse, fallbackMessage?: string): string {
    const errors = error?.error?.errors;

    if (errors && typeof errors === 'object') {
      for (const key in errors) {
        if (errors[key]) {
          const value = errors[key];
          const originalMsg = this.normalizeMessage(value);
          if (originalMsg) {
            return this.translateOrDefault(originalMsg);
          }
        }
      }
    }

    const detailMsg = this.normalizeMessage(error?.error?.detail);
    if (detailMsg) {
      return this.translateOrDefault(detailMsg);
    }

    const errorMsg = this.normalizeMessage(error?.error?.message ?? error?.message);
    if (errorMsg) {
      return this.translateOrDefault(errorMsg);
    }

    return this.getDefaultErrorMessage(fallbackMessage);
  }

  private normalizeMessage(value: unknown): string | null {
    if (!value) {
      return null;
    }

    if (Array.isArray(value)) {
      const message = value.find((item) => typeof item === 'string' && item.trim());
      return message ? message.trim() : null;
    }

    if (typeof value === 'string') {
      const trimmed = value.trim();
      return trimmed.length ? trimmed : null;
    }

    return null;
  }

  private translateOrDefault(message: string): string {
    const translated = this.translocoService.translate(message);
    return translated === message ? message : translated;
  }

  private getDefaultErrorMessage(fallbackMessage?: string): string {
    return this.translocoService.translate(fallbackMessage ?? 'Ocorreu um erro, tente novamente em outro momento');
  }
}
